import {store} from '@/integrations/store'
import helpers from '@/utils/helpers'

const themeColorHEX = store.getters['themeColorHEX']

// Temporary disabled (doesn't have much usecases)
// function checklist({data}) {
//   let html = ''
//   data.items.forEach(item => {
//     html += `<div class="flex items-center gap-2 py-1">
//                 ${
//                   item.checked
//                     ? `<div class="w-5 h-5 rounded-md flex items-center justify-center" style="background: #369fff; color: #fff"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 12L10.4884 15.8372C10.5677 15.9245 10.705 15.9245 10.7844 15.8372L17 9"></path></svg></div>`
//                     : `<div class="w-5 h-5 rounded-md flex items-center justify-center" style="background: #fff; outline: 1px solid #c9c9c9; outline-offset: -1px;"></div>`
//                 }
//                 ${item.text}
//             </div>`
//   })
//   return html
// }

function paragraph({data}) {
  return `<p class="py-1">${data.text}</p>`
}

function header({data}) {
  const sizes = {
    2: 20,
    3: 18,
    4: 16
  }
  return `<h${data.level} class="font-semibold mt-4 mb-2" style="font-size: ${sizes[data.level]}px; line-height: ${
    sizes[data.level] + 4
  }px">${data.text}</h${data.level}>`
}

function image({data}) {
  let caption = data.caption || 'Image'
  return `<div class="flex flex-col gap-1 items-center py-2">
            <div class="w-full ${data.withBackground ? `bg-silver py-2 px-5` : ``}">
                <img src="${data.file.url || data.file}" alt="${caption}" class="${
    data.withBorder ? `border border-gray rounded-md` : ``
  } ${data.stretched ? `w-full` : ``}" />
            </div>
            ${data.caption ? `<span class="text-14 text-gray">${caption}</span>` : ``}
        </div>`
}

function quote({data}) {
  const RGB = helpers.hexToRGB(helpers.getCorrectColor(themeColorHEX))
  return `<div class="flex flex-col gap-1 py-3">
            <div class="flex gap-2 h-full" style="background: rgba(${RGB.r}, ${RGB.g}, ${RGB.b}, 0.05)">
                <div class="min-w-1 max-w-1 rounded-tl-md rounded-bl-md" style="background: ${helpers.getCorrectColor(
                  themeColorHEX
                )}"></div>
                <span class="text-16">${data.text}</span>
            </div>
            <span class="text-14 text-gray italic font-semibold ml-4">— ${data.caption}</span>
        </div>`
}

function delimiter() {
  return `<div class="flex gap-2 mx-5 my-5 relative items-center">
            <div class="h-px bg-silver w-full"></div>
            <span class="whitespace-nowrap mt-[6px]">***</span>
            <div class="h-px bg-silver w-full"></div>
          </div>`
  // return `<div class="h-px flex mx-5 bg-silver my-5 relative before:content-['***'] before:absolute before:text-silver before:bg-white before:leading-5 before:-top-[6px] before:text-24 before:px-2 before-center"></div>`
}

function table({data}) {
  return `
  <div class="max-w-full w-full overflow-x-scroll mt-4 pb-4">
    <table class="min-w-full">
        ${
          data.withHeadings
            ? `<thead>
                    <tr class="border">
                        ${data.content[0].map(heading => `<th class="border min-w-[125px]">${heading}</th>`).join('')}
                    </tr>
                </thead>`
            : ``
        }
            <tbody>
            ${
              data.withHeadings
                ? `${data.content
                    .slice(1)
                    .map(
                      body =>
                        `<tr class="border">
                            ${body.map(text => `<td class="border min-w-[125px]">${text}</td>`).join('')}
                        </tr>`
                    )
                    .join('')}`
                : `${data.content
                    .map(
                      body =>
                        `<tr class="border">
                            ${body.map(text => `<td class="border min-w-[125px]">${text}</td>`).join('')}
                        </tr>`
                    )
                    .join('')}`
            }
            </tbody>
        </table>
    </div>
  `
}

// Potentialy problematic. Postponed till further research.
// function code({data}) {
//   return `
//         <div class="flex flex-col rounded-md overflow-hidden my-2">
//             <div class="w-full bg-[#2f2f2f] flex justify-start px-2 py-1">
//                 <span class="text-[#e6e6e6]">Code Snippet</span>
//             </div>
//             <pre class="bg-[#0d0d0d] p-2 flex items-center justify-start min-h-10">
//                 <code class="w-full whitespace-pre-wrap break-word text-[#e6e6e6]">${data.code}</code>
//             </pre>
//         </div>
//         `
// }

function warning({data}) {
  return `
        <div class="flex gap-2 items-start my-3 bg-yellow/20 p-3 rounded-md overflow-hidden">
            <div class="w-6 h-6 min-w-6 text-[#ffaf1f]">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M142.41,40.22l87.46,151.87C236,202.79,228.08,216,215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22C119.89,29.26,136.11,29.26,142.41,40.22Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="144" x2="128" y2="104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="128" fill="currentColor" cy="180" r="12"/></svg>
            </div>
            <div class="flex flex-col">
                <span class="text-18 font-semibold text-[#ffaf1f]">${data.title}</span>
                <span class="text-14 text-[#ffaf1f]">${data.message}</span>
            </div>
        </div>
        `
}

// Potentialy problematic. Postponed till further research.
// function raw({data}) {
//   return `
//           <div class="flex flex-col rounded-md overflow-hidden my-2">
//               <div class="w-full bg-[#2f2f2f] flex justify-start px-2 py-1">
//                   <span class="text-[#e6e6e6]">Raw HTML</span>
//               </div>
//               <pre class="bg-[#0d0d0d] p-2 flex items-center justify-start min-h-10">
//                   <code class="w-full whitespace-pre-wrap break-word text-[#e6e6e6]">${data.html}</code>
//               </pre>
//           </div>
//           `
// }

function linkTool({data}) {
  const RGB = helpers.hexToRGB(helpers.getCorrectColor(themeColorHEX))
  return `<a href="${data.link}" target="_blank" class="flex gap-2 p-2 rounded-md" style="background: rgba(${RGB.r}, ${RGB.g}, ${
    RGB.b
  }, 0.05)">
            ${
              data.meta && data.meta.image && data.meta.image.url
                ? `
            <img src="${data.meta.image.url}" class="min-w-12 min-h-12 max-w-12 max-h-12 rounded-md object-cover" />
            `
                : ``
            }
            <div class="flex flex-col w-full">
              ${data.meta && data.meta.title ? `<span class="text-16 font-semibold text-black">${data.meta.title}</span>` : ``}
              <span class="text-14 text-gray">${data.link}</span>
            </div>
            <div class="flex my-auto text-gray min-w-5 min-h-5 max-w-5 max-h-5">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="216 104 215.99 40.01 152 40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="136" y1="120" x2="216" y2="40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M184,136v72a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h72" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>
            </div>
          </a>`
}

export default {
  // checklist,
  paragraph,
  header,
  image,
  quote,
  delimiter,
  table,
  // code,
  warning,
  // raw,
  linkTool
}
